export class CourtSystemConfiguredWithTestPaymentKey extends Error {
  constructor() {
    super(
      'This court system is configured with a test Stripe API key. You must update the API key to a production ' +
        'one before publishing the court system.',
    )
    Object.setPrototypeOf(this, CourtSystemConfiguredWithTestPaymentKey.prototype)
  }
}
